import { ButtonsWrapper } from './styles/ButtonsWrapper';
import { CopyRight } from './styles/CopyRight';
import { Footer } from './styles/Footer';
import { Root } from './styles/Root';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { TermsPrivacy } from './styles/TermsPrivacy';
import { WaveWrapper } from './styles/WaveWrapper';
import Wave from './wave.svg';

export const InternalErrorPage = () => {
  const onClick = () => {
    window.location.href =
      process.env.NODE_ENV === 'development' ? localStorage.getItem('previous500page') || '/' : '/';
  };

  return (
    <Root>
      <h1>Something went wrong...</h1>
      <p>AutoScript team is working to resolve the problem, please try again later.</p>
      <WaveWrapper>
        <Wave />
      </WaveWrapper>
      <ButtonsWrapper>
        <OutlinedButton className="w-[130px]" onClick={onClick}>
          Go Back
        </OutlinedButton>
      </ButtonsWrapper>
      <Footer>
        <TermsPrivacy>
          <a href="https://voicescript.ai/privacy-policy/" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>{' '}
          |{' '}
          <a href="https://voicescript.ai/terms-of-service/" target="_blank" rel="noreferrer">
            Terms of Service
          </a>
        </TermsPrivacy>
        <CopyRight>&copy; {new Date().getFullYear()} VoiceScript Inc. All Rights Reserved</CopyRight>
      </Footer>
    </Root>
  );
};
